// extracted by mini-css-extract-plugin
export var darkTheme = "footer-module--dark-theme--Dwsc3";
export var footerCopyrights = "footer-module--footerCopyrights--SpwjH";
export var footerWrapper = "footer-module--footerWrapper--dW1hK";
export var icons = "footer-module--icons--epnTW";
export var space = "footer-module--space--Ukdtv";